import RemoteCollection from "#root/utility/remote-collection";
import { z } from "zod";

export const AccountListItemSchema = z.object({
  id: z.number(),
  type: z.string().nullish(),
  name: z.string().nullish(),
  website: z.string().nullish(),
});

export const AccountDetailItemSchema = AccountListItemSchema.extend({
  affiliate: z.string().nullish(),
  lei: z.string().nullish(),
  taxId: z.string().nullish(),
  billingAddress: z.string().nullish(),
  lastUsage: z.string().nullish(),
  firstUsage: z.string().nullish(),
}).loose();

export type AccountListItem = z.output<typeof AccountListItemSchema>;
export type AccountDetailItem = z.output<typeof AccountDetailItemSchema>;

export const accountCollection = new RemoteCollection("/api/account", AccountListItemSchema, AccountDetailItemSchema);
